import Heading from '@tiptap/extension-heading';

export const ExtendedHeading = Heading.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      // Set the default level to 2 (h2)
      level: {
        default: 2,
      },
    };
  },
});
